import WebComponent from '../../WebComponent.js'
import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Dropdown/Dropdown.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/List/List.js'
import '@isceco/widget-library2/basic-elements/Card/Card.js'
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup.js'
import '@isceco/widget-library2/basic-elements/Filter/MultiselectFilter.js'
import StringColumn from '@isceco/widget-library2/basic-elements/List/column/StringColumn.js'
import EvaluationService from './EvaluationService.js'
import DropdownMultiselectColumn from '@isceco/widget-library2/basic-elements/List/column/DropdownMultiselectColumn.js'
import Nutzungsgruppe from '../WohnobjektEdit/Nutzungsgruppe.js'
import Nutzungsanliegen from '../WohnobjektEdit/Nutzungsanliegen.js'
import Land from '../WohnobjektEdit/Land.js'
import AuswertungenRowVariant from './AuswertungenRowVariant.js'

export default class Auswertungen extends WebComponent {
  get translationFile() {
    return './views/Auswertungen/i18n.json'
  }

  get css() {
    return [
      css`
        .total {
          margin: 0 auto var(--isceco-space-300);
          max-width: fit-content;
        }

        .year {
          max-width: 400px;
          margin: 0 auto var(--isceco-space-200);
        }

        .year > * {
          width: 200px;
          flex: 1;
        }
      `
    ]
  }

  connectedCallback() {
    super.connectedCallback()

    this.year = getNavigationId()
    this.evaluationService = new EvaluationService()
    this.years = []
    if (this.year) {
      Promise.all([this.evaluationService.list(`years`), this.evaluationService.read(`${this.year}/total`), this.evaluationService.getBackendListUrl(`${this.year}/wohnobjekte`)])
        .then(([years, total, url]) => {
          this.years = years.map(v => ({value: v, name: v.toString()}))
          this.total = total
          this.url = url
          this.render()
        })
    } else {
      this.evaluationService.list(`years`)
        .then(years => {
          this.years = years.map(v => ({value: v, name: v.toString()}))
          this.render()
        })
    }
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('page.header')}"></isceco-title>

      <div class="inline year">
        <isceco-dropdown id="year"
                         inline
                         required
                         label="${this.i18n.translate('auswertungen.year')}"
                         .items="${this.years}"
                         value="${this.year}"
        ></isceco-dropdown>
        <isceco-button id="execute"
                       text="${this.i18n.translate('auswertungen.execute')}"
                       variant="primary"
                       @click="${this.execute}"
        ></isceco-button>
      </div>

      <div class="inline total">
        ${this.renderTotal('auswertungen.total', this.total, 'total')}
        ${this.renderTotal('auswertungen.total.filtered', this.totalFiltered, 'total-filtered')}
      </div>

      ${this.renderResults()}
    `
  }

  renderTotal(title, total, id) {
    return html`
      <isceco-card text="${this.i18n.translate(title, {year: this.year ?? ''})}">
        ${this.i18n.translate('auswertungen.wohnobjekte')}:
        <span id="${id}-wohnobjekte">${total?.wohnobjekte ?? 0}</span>
        <br/>
        ${this.i18n.translate('auswertungen.wohnobjekteMitGebrauchswert')}:
        <span id="${id}-wohnobjekteMitGebrauchswert">${total?.wohnobjekteMitGebrauchswert ?? 0}</span>
        <br/>
        ${this.i18n.translate('auswertungen.wohnungen')}:
        <span id="${id}-wohnungen">${total?.wohnungen ?? 0}</span>
        <br/>
        ${this.i18n.translate('auswertungen.gebrauchswert')}:
        <span id="${id}-gebrauchswert">${total?.gebrauchswert ?? 0}</span>
      </isceco-card>
    `

  }

  renderResults() {
    if (this.url) {
      return html`
        <isceco-filter-group>
          <isceco-multiselect-filter key="nutzungsgruppe"
                                     label="${this.i18n.translate('auswertungen.nutzungsgruppe')}"
                                     .items="${Nutzungsgruppe.ITEMS}"
                                     .i18n="${this.i18n}"
          ></isceco-multiselect-filter>
          <isceco-multiselect-filter key="nutzungsanliegen"
                                     label="${this.i18n.translate('auswertungen.nutzungsanliegen')}"
                                     .items="${Nutzungsanliegen.ITEMS}"
                                     .i18n="${this.i18n}"
          ></isceco-multiselect-filter>
          <isceco-multiselect-filter key="land"
                                     label="${this.i18n.translate('auswertungen.land')}"
                                     .items="${Land.ITEMS}"
                                     .i18n="${this.i18n}"
          ></isceco-multiselect-filter>
          <isceco-string-filter key="minGebrauchswert"
                                label="${this.i18n.translate('auswertungen.minGebrauchswert')}"
          ></isceco-string-filter>
        </isceco-filter-group>

        <isceco-list id="wohnobjekte"
                     .i18n="${this.i18n}"
                     .columns="${this.columns()}"
                     .url="${this.url}"
                     .rowVariant="${new AuswertungenRowVariant()}"
                     @isceco-list-updated="${this.updateTotal}"
        ></isceco-list>
      `
    } else {
      return html``
    }
  }

  updateTotal = () => {
    this.evaluationService.read(`${this.year}/total?${getNavigationParams().toString()}`)
      .then(total => {
        this.totalFiltered = total
        this.render()
      })
  }

  execute = () => {
    const yearInput = this.querySelector('#year')
    if (yearInput.validate()) {
      const year = yearInput.getValue()
      navigate({id: year})
    }
  }

  columns = () => [
    new StringColumn({
      key: 'titel',
      text: 'auswertungen.titel',
      sortable: true
    }),
    new StringColumn({
      key: 'standort',
      text: 'auswertungen.standort'
    }),
    new DropdownMultiselectColumn({
      key: 'nutzungsgruppe',
      text: 'auswertungen.nutzungsgruppe',
      items: Nutzungsgruppe.ITEMS,
      sortable: true
    }),
    new DropdownMultiselectColumn({
      key: 'nutzungsanliegen',
      text: 'auswertungen.nutzungsanliegen',
      items: Nutzungsanliegen.ITEMS,
      sortable: true
    }),
    new StringColumn({
      key: 'gebrauchswertWohnanlage',
      text: 'auswertungen.gebrauchswertWohnanlage'
    }),
    new StringColumn({
      key: 'gebrauchswertWohnstandort',
      text: 'auswertungen.gebrauchswertWohnstandort'
    }),
    new StringColumn({
      key: 'gebrauchswertWohnungstypen',
      text: 'auswertungen.gebrauchswertWohnungstypen'
    }),
    new StringColumn({
      key: 'wohnungstypen',
      text: 'auswertungen.wohnungstypen'
    }),
    new StringColumn({
      key: 'gebrauchswert',
      text: 'auswertungen.gebrauchswert'
    })
  ]
}

customElements.define('tool-frontend-auswertungen', Auswertungen)
